import { render, staticRenderFns } from "./PaginationWidget.vue?vue&type=template&id=5d1cea2e&"
import script from "./PaginationWidget.vue?vue&type=script&lang=js&"
export * from "./PaginationWidget.vue?vue&type=script&lang=js&"
import style0 from "./PaginationWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
